import React from 'react';
import { Tag } from '@chargify/custom-ui-components';
import { InvoiceStatus } from '../../../models/billingHistory/billingHistory';
import { useTranslation } from 'react-i18next';

interface StatusProps {
  status: InvoiceStatus;
}
export const Status = ({ status }: StatusProps) => {
  const { t } = useTranslation('billing-history');
  switch (status) {
    case 'paid':
      return <Tag label={t('paid')} color={'success'} />;
    case 'open':
      return <Tag label={t('open')} color={'primary'} />;
    case 'voided':
      return <Tag label={t('voided')} color={'gray'} />;
    case 'pending':
      return <Tag label={t('pending')} color={'primary'} />;
    case 'draft':
      return <Tag label={t('draft')} color={'gray'} />;
    case 'canceled':
      return <Tag label={t('canceled')} color={'gray'} />;
    default:
      return null;
  }
};
